// import MoeSoftAsk from "../../../src/components/MoeSoftAsk";
import dynamic from 'next/dynamic';
// import CategoryPage from "../../src/components/CategoryDetail";
// import CategoryL2Page from "../../src/components/CategoryL2Page";
import { showNewCategoryUI } from '../../src/components/StoreCategoryPage/common';
import { maternityWear } from '../../src/Constants/GeneralItemsKeys';
import {
  categoryNavBarDataFetcher,
  GetSubCategoriesData,
  tabByKeyFetcher,
} from '../../src/datafetchers/CategoryPage';
import {
  getCookieValue,
  l1CategoryIds,
  OldCategoryIdUrlMapping,
} from '../../src/Utils/commonUtils';
import {
  convertToQuery,
  getCategoryKey,
  getFilteredCategoryContent,
  getSubCategoryFilter,
  removeDefaultParams,
} from '../../src/Utils/helper';
// import CategoryPageNew from "../../src/components/CategoryDetail/CategoryPageNew";
const CategoryPageNew = dynamic(
  () => import('../../src/components/CategoryDetail/CategoryPageNew'),
  {
    ssr: true,
  },
);
const CategoryPage = dynamic(
  () => import('../../src/components/CategoryDetail'),
  {
    ssr: true,
  },
);

const CategoryL2Page = dynamic(
  () => import('../../src/components/CategoryL2Page'),
  {
    ssr: true,
  },
);

export async function getServerSideProps(context) {
  let categoryStaticData = {};
  let categoryNavBarApiData = {};
  let subCategoriesData = {};
  let breadCrumbs = [];
  let category_name = context.params.categoryname;
  let url_id = category_name?.split('-')?.pop() || category_name;
  let category_id = getCategoryKey(category_name);
  if (OldCategoryIdUrlMapping[url_id]) {
    const query = removeDefaultParams(context.query);
    let qs = convertToQuery(query);
    let redirectPath = OldCategoryIdUrlMapping[url_id];
    if (qs) {
      redirectPath += '?' + qs;
    }
    return {
      redirect: {
        destination: redirectPath,
        statusCode: 301,
      },
    };
  }

  const catId = context.query.categoryId || null;
  // let selectedtabId = context.query.tabs || "All";

  let cookieString = context.req.headers.cookie;

  let userType = getCookieValue(cookieString, 'shopData');
  let selectedTab = getCookieValue(cookieString, 'selectedTab');
  if (!userType) {
    let shop_data =
      Math.abs(Math.floor(1 + Math.random() * 2)) == 1 ? 'A' : 'B';
    userType = {
      userType: shop_data,
    };
    userType = JSON.stringify(userType);
    context.res.setHeader('Set-Cookie', `shopData=${userType}; Path=/;`);
  }
  let showNewUI = true;
  let isL0Category = false;
  let oldL2Page = false;
  // if (isNaN(category_id)) {
  //     return {
  //         notFound: true,
  //     };
  // }
  try {
    let apiRequiredData = {
      'key': showNewCategoryUI(showNewUI, category_id)
        ? maternityWear
        : category_id,
      'skip': 0,
      'limit': 4,

      'Mylo-In-App': false,
      'userType': 'A',
    };

    categoryStaticData = await tabByKeyFetcher(apiRequiredData);
    categoryNavBarApiData = await categoryNavBarDataFetcher();
    isL0Category = checkIsL0Category(categoryNavBarApiData?.data, category_id);
    oldL2Page = showOldL2Page(category_id);
    // if (isL0Category || oldL2Page)
    const skipSubCategoryData =
      category_id.toString().includes('bestsellers') ||
      (!isL0Category && !oldL2Page);
    subCategoriesData = skipSubCategoryData
      ? []
      : await GetSubCategoriesData(category_id, isL0Category);
    breadCrumbs = categoryStaticData?.data?.breadcrumbs;
  } catch (error) {
    const errorString = `Error generating page with ID: ${context.params.categoryname}, ${error}`;
    console.log('errorString', errorString);
    if (error?.response?.status == '400' || error?.response?.status == '404') {
      return {
        notFound: true,
        //revalidate: 60,
      };
    } else throw error;
  }
  const selectTab = selectedTab ? JSON.parse(selectedTab) : null;
  return {
    props: {
      categoryStaticData: categoryStaticData,
      // categoryStaticData: getFilteredCategoryData(
      //     categoryStaticData,
      //     isL0Category,
      // ),
      categoryNavBarData: getFilteredCategoryContent(
        categoryNavBarApiData?.data,
      ),
      webUrl: context.params.categoryname,
      subCategoriesData: getSubCategoryFilter(
        subCategoriesData?.data,
        isL0Category,
      ),

      breadCrumbsData: breadCrumbs || null,
      showNewUI: showNewUI,
      categoryId: category_id,
      userType: JSON.parse(userType).userType,
      isL0Category: isL0Category,
      catId: catId,
      selectedTab: selectTab?.id === category_id ? selectTab : null,
      oldL2Page: oldL2Page,
    },
  };
}

const showOldL2Page = (categoryId) => {
  return !l1CategoryIds.includes(Number(categoryId));
};
const checkIsL0Category = (categoryNavBarData, categoryId) => {
  if (categoryId === '7545' || categoryId === '7546') return true;
  return false;

  // const allL0Categories = [];
  // categoryNavBarData?.map((categoryNavBar) => {
  //     categoryNavBar?.subCategories?.map((subCategory) => {
  //         allL0Categories.push(subCategory._id);
  //     });
  // });
  // return allL0Categories.includes(categoryId);
};
export default function CategoryPageMain(props) {
  const { isL0Category, oldL2Page, categoryId } = props;
  return isL0Category ? (
    <CategoryPageNew {...props} L1Page={true} />
  ) : oldL2Page ? (
    <CategoryPage {...props} />
  ) : (
    <CategoryL2Page {...props} />
  );
}
